import React, { useState, useEffect, useRef } from "react";
import "./Chatbot.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments, faTimes } from "@fortawesome/free-solid-svg-icons";

function Chatbot() {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");

  // 👇 create a ref for chat body
  const chatBodyRef = useRef(null);

  const toggleChat = () => {
    if (!isOpen && messages.length === 0) {
      setMessages([
        { sender: "bot", text: "🏗️ Welcome to Wright Brothers Contracting Services!\n🤖 I’m the WBCS Chatbot — here to help with any questions about our compnay, services, projects, or contact info."
 }
      ]);
    }
    setIsOpen(!isOpen);
  };

  // 👇 scroll to bottom when messages change
  useEffect(() => {
    if (chatBodyRef.current) {
      chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
    }
  }, [messages]);

  const getBotReply = (msg) => {
    const message = msg.toLowerCase();

    if (message.includes("email") || message.includes("company email")) {
      return "You can reach us at\n 📧officeassistant@wrightbrotherscs.com\n or \n 📧hr@wrightbrotherscs.com";
    } else if (message.includes("phone") || message.includes("contact")) {
      return "Our main line is \n📞(561) 629-7749";
    } else if (message.includes("address")) {
      return "Our office is located at: \n 📍6715 White Drive, Riviera Beach, FL 33407";
    } else if (message.includes("service")) {
      return "We provide 👷‍♂️ HVAC, Plumbing, and Electrical contracting services.";

    } else if (message.includes("director") || message.includes("operation")){
      return " Our company Director of Operations is 👤Vishal Singh.\n\n Vishal has an educational background in Civil Engineering and Construction Management. He brings with him strong experience and educational background from the construction industry. ";
    } else if (message.includes("president") || message.includes("ceo") || message.includes("founder")) {
      return "Our company President/Founder is 👤Mr. Alex Yin Kyi.\n\n Mr.Alex is Mechanical Engineer by education. He founded Wright Brothers as a HVAC service and repair company in 2008. Keeping his strong belief in customer satisfaction, the company has contributed to multiple projects in South Florida region and is expanding the boundaries.";
    } else if (message.includes("executive") || message.includes("project executive")) {
      return "Our company Project Executive is 👤Richard Kaplan.\n\n Richard is responsible for leading Plumbing Division and oversees multiple projects and project teams. He provides leadership on our projects from the early stages of preconstruction through the project delivery to our clients. Richard brings over twenty-two years of project experience to this role.";
    
    }else if (message.includes("company") || message.includes("about")) {
    return "🏗️ **About Wright Brothers Contracting Services, Inc.**\n\nServing Florida since 2008, Wright Brothers is a licensed MEP and General Contracting firm founded by Alex Yin Kyi. We provide HVAC, Plumbing, Electrical, and Mechanical services across residential and commercial sectors — from Orlando to Miami.\n\nBuilt on the values of **Commitment, Integrity, and Reliability**, our dedicated team delivers quality workmanship, competitive pricing, and complete in-house solutions for every project.";


    
    } else if (message.includes("precon") || message.includes("bid") || message.includes("proposal")) {
      return "For Preconstruction services, please contact our Precon Team Head:\n 👤Vishal Singh at:\n 📧vsingh@wrightbrotherscs.com";
    } else if (message.includes("hvac")) {
      return "For HVAC service related queries, please contact our Assistant Project Manager: 👤Balaji Nagaraja at:\n 📧bnagaraj@wrightbrotherscs.com";
    } else if (message.includes("plumbing")) {
      return "For Plumbing service related queries, please contact our Senior Project Manager: 👤Nithish Venkatesh at: \n 📧nvenkatesh@wrightbrotherscs.com";
    } else if (message.includes("electrical")) {
      return "For Electrical service related queries, please contact our Department Manager: 👤Kristel Grimes at:\n 📧kgrimes@wrightbrotherscs.com";
    } else if(message.includes("account") || message.includes("finance")){
      return "For Accounting and Finance related queries, please contact our Senior Accountant: 👤Vivian at:\n 📧vivian@wrightbrotherscs.com";
    } else if (message.includes("hr") || message.includes("human resource")) {
      return "For Human Resource related queries, please contact our HR: 👤Sai Goriparthi at:\n 📧svidhya@wrightbrotherscs.com";
    } else if (message.includes("warehouse") || message.includes("inventory")) {  
      return "For Warehouse and Inventory related queries, please contact our Warehouse Manager: 👤Jose Ceredena at:\n 📧jcerdena@wrightbrotherscs.com";
    } else if (message.includes("manager") || message.includes("project manager")) {
      return "For Project Management related queries, please contact our Project Manager:👤Mostafa Elalfy at:\n 📧melalfy@wrightbrotherscs.com\n or \n👤Jason Phillips at:\n 📧jphillips@wrightbrotherscs.com";
    } else if (message.includes("material") || message.includes("procurement") || message.includes("purch")) {
      return "For Plumbing Procurement and Material related queries, please contact our Assistant Procurement Manager: 👤Aashna Rahman at:\n 📧arahman@wrightbrotherscs.com \n\n  For HVAC Procurement and Material related queries, please contact our Assistant Project Manager: 👤Balaji Nagaraja at:\n 📧bnagaraja@wrightbrotherscs.com \n\n For Electrical Procurement and Material related queries, please contact our Electrical Department Manager:👤Kristel Grimes at:\n 📧kgrimes@wrightbrotherscs.com";


     
    } else if (message.includes("project")) {
      return "Some of our ongoing projects: \n Caretta, Tyson Apartments, Coral Gables, Heritage, Perrine Village, Aventana, Tampa 47 th St., Marina Village. \n Recently completed major projects:\n FB Wynwood ,Culmer Apartments, Riverstone Apartments.\n For more details, visit our Projects page at https://www.wrightbrotherscs.com/projects";
    } else if (message.includes("job")) {
      return "For 💼job opportunity please email your resume to 📧hr@wrightbrotherscs.com.";
    



    }else if (message.includes("insta")) {
      return "You can follow us on Instagram at: \n https://www.instagram.com/wrightbrotherscs/";
    } else if (message.includes("facebook")) {
      return "You can follow us on Facebook at: \n https://www.facebook.com/WrightBrothersCS/";
    }  else if (message.includes("linkedin")) {
      return "You can follow us on LinkedIn at: \n https://www.linkedin.com/company/wright-brothers-contracting-services/";
    }  else if (message.includes("twitter")) {
      return "You can follow us on Twitter at: \n https://x.com/WrightBroCS";

    
    
    
    
    
    } else {
      return "I'm here to help! You can ask about our company email, phone, address, or different services like plumbing, hvac, electrical, projects, contact information.";
    }
  };

  const handleSend = () => {
    if (!input.trim()) return;
    const userMsg = { sender: "user", text: input };
    const botMsg = { sender: "bot", text: getBotReply(input) };

    setMessages([...messages, userMsg, botMsg]);
    setInput("");
  };

  return (
    <div className="chatbot-container">
      {isOpen && (
        <div className="chat-window">
          <div className="chat-header">WBCS Chatbot</div>
          
          {/* 👇 attach the ref here */}
          <div className="chat-body" ref={chatBodyRef}>
  {messages.map((m, i) => (
    <div
      key={i}
      className={`message ${m.sender}`}
      dangerouslySetInnerHTML={{ __html: m.text.replace(/\n/g, "<br/>") }}
    ></div>
  ))}
</div>

          <div className="chat-footer">
            <input
              type="text"
              placeholder="Type a message..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSend()}
            />
            <button onClick={handleSend}>Send</button>
          </div>
        </div>
      )}

      <button className="chat-toggle-btn" onClick={toggleChat}>
        <FontAwesomeIcon icon={isOpen ? faTimes : faComments} className="chat-icon" />
      </button>
    </div>
  );
}

export default Chatbot;
